import type { PiniaPlugin } from 'pinia';

// Pinia equivalent of the Vuex analytics plugin (src/vuex/plugins/analytics.js).
// Each store that needs re-identification wires up its $subscribe logic here
// when it migrates. Only subscribes on stores that actually need it.
export const analyticsPlugin: PiniaPlugin = ({ store }) => {
    if (store.$id === 'auth') {
        // APP-157986: re-identify when user profile fields change
        // (equivalent to auth/setProperty with reIdentify: true)
        // store.$subscribe(() => { ... });
    }

    if (store.$id === 'userSettings') {
        store.$onAction(({ name, args, after }) => {
            if (name !== 'update') return;
            const settingName = (args[0] as { name?: string })?.name ?? '';
            if (!settingName.startsWith('discoverGetStartedPreferences')) return;
            after(() => import('@/vuex/plugins/analytics').then(({ identify }) => identify()));
        });
    }
};
